import VueCookie from 'vue-cookie'
const cookie = {
  // 获取cookie
  getCookie (key) {
    return VueCookie.get(key)
  },
  // 设置cookie
  setCookie (key, val) {
    return VueCookie.set(key, val, { expires: '1d' })
  },
  // 删除cookie
  removeCookie (key) {
    return VueCookie.delete(key)
  }
}
export default cookie
